<template>
    <div class="archive-entry">
        <h4 class="archive-entry-title entry-hint-parent">{{ prefix }}{{ data.name }}
            <span class="entry-hint" title="Draft">
                <svg fill="none" shape-rendering="geometricPrecision" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" viewBox="0 0 24 24" height="12" width="12">
                    <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"></path>
                    <path d="M15 3h6v6"></path>
                    <path d="M10 14L21 3"></path>
                </svg>
            </span>
        </h4>
        <div class="archive-meta">
            <span>{{ data.description }}</span><br>   
            <span>Primary language: {{ data.primaryLanguage.name }}</span>
        </div>
        <a class="entry-link" :href="data.url" target="_blank"></a>
    </div>
  </template>
  <script>
  export default {
    name: 'Pinned',
    props: ['data'],
    data() {
        return {
            prefix: 'davidlares/'
        }
    }
  }
  </script>
  